// AUTO GENERATED FILE - Changes WILL be lost.
// pl - used as 'pl' fallback
export const common_fallback = true

export const translations = {
  "betslip.title": "Kupon",
  "product.last60-row-single": "NBA Last 60",
  "product.sb-english-single": "Liga angielska",
  "product.sb-italian-single": "Liga włoska",
  "product.sb-greek-single": "Liga grecka",
  "product.sb-english-league": "Liga angielska",
  "product.sb-italian-league": "Liga włoska",
  "product.sb-greek-league": "Liga grecka",
  "last60.fixture.pending": "{visitor} {'@'} {home}",
  "last60.fixture.result": "{visitor} ({visitorScore}) {'@'} ({homeScore}) {home}",
  "sb.fixture.pending": "{home} VS. {away}",
  "sb.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "betslip.bet": "Postaw zakład",
  "betslip.clear": "Wyczyść wszystko",
  "betslip.clearResult": "Wyczyść",
  "betslip.noSelections": "Dodaj zakłady",
  "betslip.notLoggedIn": "Zaloguj",
  "betslip.refresh": "Odśwież",
  "betslip.totalStake": "Stawka",
  "betslip.noHistoryData": "Brak informacji o zakładzie",
  "betslip.openBets": "Otwarte zakłady",
  "betslip.betHistory": "Historia zakładów",
  "betslip.betHistoryWon": "Wygrane",
  "betslip.betHistoryLost": "Przegrane",
  "loading.loading": "Ładowanie",
  "loading.account": "Ładowanie konta",
  "loading.league": "Ładowanie ligi",
  "loading.gameweeks": "Ładowanie kolejek",
  "loading.markets": "Ładowanie rynków",
  "loading.bethistory": "Ładowanie historii",
  "login.loginRequired": "Logowanie wymagane",
  "login.loginToBet": "Proszę się zalogować",
  "navigation.back": "Powrót",
  "navigation.close": "Zamknij",
  "video.liveStreamAvailable": "Dostępne video",
  "video.logInToWatch": "Proszę się zalogować, aby oglądać",
  "error.error": "Błąd",
  "error.404": "Strona nie znaleziona",
  "error.gameLaunchFailed": "Nie można uruchomić gry",
  "error.unknownErrorCode": "Nieznany błąd: {code}",
  "error.minUnitStakeLimitExceeded": "Minimalna stawka wynosi {limit}",
  "error.maxUnitStakeLimitExceeded": "Maksymalna stawka wynosi {limit}",
  "error.minTotalStakeLimitExceeded": "Minimalna stawka wynosi {limit}",
  "error.maxTotalStakeLimitExceeded": "Maksymalna stawka wynosi {limit}",
  "error.stakeInvalidMultiple": "Stawka musi być wielokrotnością {multiple}",
  "error.notPlaced": "Zakład odrzucony",
  "error.wagerDisallowed": "Niedozwolony zakład",
  "error.errorEventIsOff": "Zdarzenie się rozpoczeło",
  "wagerType.Singles": "Singiel",
  "wagerType.Doubles": "Duble",
  "wagerType.Trebles": "Treble",
  "wagerType.Accumulator": "Multi",
  "wagerType.Perm 4-Folds": "Sys. 4-zdarzenia",
  "wagerType.Perm 5-Folds": "Sys. 5-zdarzeń",
  "wagerType.Perm 6-Folds": "Sys. 6-zdarzeń",
  "wagerType.Perm 7-Folds": "Sys. 7-zdarzeń",
  "wagerType.Perm 8-Folds": "Sys. 8-zdarzeń",
  "wagerType.Perm 9-Folds": "Sys. 9-zdarzeń",
  "error.excess_bets": "Przekroczono maksymalną liczbę zdarzeń: {limit}",
  "product.sb-turkish-league": "Liga turecka",
  "error.minBetslipLimitExceeded": "Minimalna stawka kuponu wynosi {limit}.",
  "error.maxBetslipLimitExceeded": "Maksymalna stawka kuponu wynosi {limit}.",
  "error.exceededMaxPayout": "Maksymalna wygrana wynosi {limit}; proszę zmniejszyć stawkę.",
  "betslip.potentialReturns": "Potencjalna wygrana",
  "betslip.taxDisclaimer": "Wszystkie wygrane netto są opodatkowane po rozliczeniu zakładu. Kwota podatku zostanie obliczona w zależności od potencjalnej wygranej zakładu.",
  "error.maintenanceEnabled": "Obecnie trwają prace konserwacyjne.",
  "error.internalError": "Błąd wewnętrzny.",
  "error.invalidSession": "Sesja jest nieważna.",
  "error.accountDisabled": "Konto jest nieaktywne.",
  "error.invalidPlayerID": "Nieprawidłowy identyfikator gracza.",
  "error.insufficientBalance": "Niewystarczająca ilość środków.",
  "error.configError": "Błąd konfiguracji",
  "error.betPlaceFailed": "Nie udało się postawić zakładu.",
  "error.invalidProductID": "Nieprawidłowy identyfikator produktu.",
  "error.playerReachedGamingLimits": "Przekroczono limit odpowiedzialnej gry.",
  "error.gameCycleDoesNotExist": "Runda nie istnieje",
  "error.betAmountLimitExceeded": "Przekroczono potencjalną kwotę wygranej dla niezweryfikowanego gracza.",
  "betslip.netStake": "Wkład",
  "betslip.tax": "Podatek",
  "error.badReturns": "Potencjalna wygrana niższa niż stawka",
  "betslip.taxDisclaimerPoland": "Wygrana zostanie pomniejszona o 10% w przypadku kwoty powyżej 2 280zł.",
  "error.incompatibleVersion": "Nieobsługiwana wersja aplikacji. Prosimy o aktualizację.",
  "product.iihf-row-single": "Mistrzostwa Świata IIHF",
  "iihf.fixture.pending": "{home} VS. {away}",
  "iihf.fixture.result": "{home} {homeScore} - {awayScore} {away}",
  "ui.returnToPlayer": "Powrót do gracza",
  "abbr.ui.returnToPlayer": "RTP",
  "ui.averageReturnToPlayer": "Średni RTP dla tej gry wynosi {limit}.",
  "error.betslipContainsInvalidOptions": "Betslip zawiera nieprawidłowe opcje w kolorze czerwonym",
  "product.sb-scottish-single": "Pojedynczy mecz w Scottish Soccerbet",
  "product.sb-spanish-single": "Pojedynczy mecz hiszpańskiego Soccerbet",
  "product.sb-spanish-league": "Hiszpańska liga zakładów piłkarskich",
  "sb-english.team.ARS": "Arsenal",
  "sb-english.team.AST": "Aston V.",
  "sb-english.team.BHA": "Brighton",
  "sb-english.team.BOU": "Bournemouth",
  "sb-english.team.BUR": "Burnley",
  "sb-english.team.CHE": "Chelsea",
  "sb-english.team.CRY": "C. Palace",
  "sb-english.team.EVE": "Everton",
  "sb-english.team.LEI": "Leicester",
  "sb-english.team.LIV": "Liverpool",
  "sb-english.team.MNC": "Manchester C.",
  "sb-english.team.MNU": "Manchester U.",
  "sb-english.team.NEW": "Newcastle",
  "sb-english.team.SOU": "Southampton",
  "sb-english.team.TOT": "Tottenham",
  "sb-english.team.WAT": "Watford",
  "sb-english.team.WHU": "West Ham",
  "sb-english.team.WOL": "Wolves",
  "sb-english.team.NOR": "Norwich",
  "sb-english.team.SHU": "Sheffield U.",
  "sb-english.team.LEE": "Leeds",
  "sb-english.team.FUL": "Fulham",
  "sb-english.team.WBA": "West Brom",
  "sb-greek.team.AEK": "AEK ATENY",
  "sb-greek.team.APS": "APOLLON SMYRNIS",
  "sb-greek.team.ARI": "ARIS THESSALONIKI",
  "sb-greek.team.AST": "ASTERAS TRIPOLI",
  "sb-greek.team.ATR": "ATROMITOS",
  "sb-greek.team.GIA": "PAS GIANNINA",
  "sb-greek.team.LEV": "LEVADIAKOS",
  "sb-greek.team.OFI": "OFI",
  "sb-greek.team.OLM": "OLIMPIAKOS",
  "sb-greek.team.PTK": "PANATHINAIKOS",
  "sb-greek.team.PNS": "PANIONIOS",
  "sb-greek.team.PAO": "PAOK SALONIKA",
  "sb-greek.team.PLT": "PLATANIA",
  "sb-greek.team.XAN": "XANTHI",
  "sb-italian.team.MIL": "Milan",
  "sb-italian.team.ATA": "Atalanta",
  "sb-italian.team.BOL": "Bologna",
  "sb-italian.team.BRE": "Brescia",
  "sb-italian.team.CAG": "Cagliari",
  "sb-italian.team.CHI": "Chievo",
  "sb-italian.team.FIO": "Fiorentina",
  "sb-italian.team.GEN": "Genoa",
  "sb-italian.team.INT": "Inter",
  "sb-italian.team.JUV": "Juventus",
  "sb-italian.team.LAZ": "Lazio",
  "sb-italian.team.NAP": "Napoli",
  "sb-italian.team.ROM": "Roma",
  "sb-italian.team.SAM": "Sampdoria",
  "sb-italian.team.UDI": "Udinese",
  "sb-italian.team.VER": "Verona",
  "nomorebets": "Koniec zakładów",
  "playtime": "Czas gry",
  "gameId": "ID gry",
  "noGames": "Brak dostępnych gier. Sprawdź wkrótce.",
  "Home": "Gospodarze",
  "Away": "Goście",
  "Visitor": "Goście",
  "rules": "Zasady",
  "soccerbet.gameWeek": "KOLEJKA",
  "soccerbet.noGameWeeks": "Brak dostępnych tygodni gry. Sprawdź wkrótce.",
  "soccerbet.league": "Tabele ligowe",
  "soccerbet.table.name": "Nazwa",
  "soccerbet.table.won": "W",
  "soccerbet.table.drawn": "R",
  "soccerbet.table.lost": "P",
  "soccerbet.table.points": "PKT",
  "abbr.event.Both Teams To Score": "OBIE DRUŻYNY STRZELĄ GOLA",
  "event.Both Teams To Score": "Obie drużyny strzelą gola",
  "event.Over / Under": "Powyżej/Poniżej",
  "event.Double Chance": "Podwójna szansa",
  "event.Match Result": "Mecz",
  "event.Exact Goals": "Dokładna liczba goli",
  "event.Correct Score": "Dokładny wynik",
  "event.Match Result Both Score": "Mecz & obie drużyny strzelą gola",
  "event.Result Und/Over 1.5 Total Goals": "Mecz & powyżej/poniżej 1.5 gola",
  "event.Result Und/Over 2.5 Total Goals": "Mecz & powyżej/poniżej 2.5 gola",
  "event.Under Over 1.5 Total Goals": "Powyżej/poniżej 1.5 gola",
  "event.Under Over 2.5 Total Goals": "Powyżej/poniżej 2.5 gola",
  "event.Under Over 3.5 Total Goals": "Powyżej/poniżej 3.5 gola",
  "event.Under Over 4.5 Total Goals": "Powyżej/poniżej 4.5 gola",
  "event.Total Goals 1 To 2": "Przedział goli 1-2",
  "event.Total Goals 1 To 3": "Przedział goli 1-3",
  "event.Total Goals 1 To 4": "Przedział goli 1-4",
  "event.Total Goals 2 To 3": "Przedział goli 2-3",
  "event.Total Goals 2 To 4": "Przedział goli 2-4",
  "event.Under Over 1.5 Home Goals": "Gospodarze - powyżej/poniżej 1.5 gola",
  "event.Under Over 1.5 Away Goals": "Goście - powyżej/poniżej 1.5 gola",
  "event.Home Team Exact Goals": "Gospodarze - dokładna liczba goli",
  "event.Away Team Exact Goals": "Goście - dokładna liczba goli",
  "event.Home Team To Score": "Gospodarze strzelą gola",
  "event.Away Team To Score": "Goście strzelą gola",
  "selection.Yes": "Tak",
  "selection.No": "Nie",
  "selection.1+G": "1&tak",
  "selection.1+Ng": "1&nie",
  "selection.X+G": "X&tak",
  "selection.X+Ng": "X&nie",
  "selection.2+G": "2&tak",
  "selection.2+Ng": "2&nie",
  "selection.1+Yes": "1&tak",
  "selection.1+No": "1&nie",
  "selection.X+Yes": "X&tak",
  "selection.X+No": "X&nie",
  "selection.2+Yes": "2&tak",
  "selection.2+No": "2&nie",
  "selection.TID_ANY_GOAL_SCORED_YES": "Tak",
  "selection.TID_ANY_GOAL_SCORED_NO": "Nie",
  "selection.U": "Poniżej",
  "selection.O": "Powyżej",
  "selection.1+O": "1 & powyżej",
  "selection.X+O": "X & powyżej",
  "selection.2+O": "2 & powyżej",
  "selection.1+U": "1 & poniżej",
  "selection.X+U": "X & poniżej",
  "selection.2+U": "2 & poniżej",
  "selection.TID_HOME_WIN": "1",
  "selection.TID_AWAY_WIN": "2",
  "selection.TID_DRAW": "X",
  "selection.TID_HOME_WIN_OR_DRAW": "1X",
  "selection.TID_DRAW_OR_AWAY_WIN": "X2",
  "selection.TID_HOME_OR_AWAY_WIN": "12",
  "selection.Over": "POWYŻEJ",
  "selection.Under": "PONIŻEJ",
  "abbr.sb-english.team.ARS": "ARS",
  "abbr.sb-english.team.AST": "AST",
  "abbr.sb-english.team.BHA": "BHA",
  "abbr.sb-english.team.BOU": "BOU",
  "abbr.sb-english.team.BUR": "BUR",
  "abbr.sb-english.team.CHE": "CHE",
  "abbr.sb-english.team.CRY": "CRY",
  "abbr.sb-english.team.EVE": "EVE",
  "abbr.sb-english.team.LEI": "LEI",
  "abbr.sb-english.team.LIV": "LIV",
  "abbr.sb-english.team.MNC": "MNC",
  "abbr.sb-english.team.MNU": "MNU",
  "abbr.sb-english.team.NEW": "NEW",
  "abbr.sb-english.team.SOU": "SOU",
  "abbr.sb-english.team.TOT": "TOT",
  "abbr.sb-english.team.WAT": "WAT",
  "abbr.sb-english.team.WHU": "WHU",
  "abbr.sb-english.team.WOL": "WOL",
  "abbr.sb-english.team.NOR": "NOR",
  "abbr.sb-english.team.SHU": "SHU",
  "abbr.sb-english.team.LEE": "LEE",
  "abbr.sb-english.team.FUL": "FUL",
  "abbr.sb-english.team.WBA": "WBA",
  "abbr.sb-italian.team.MIL": "MIL",
  "abbr.sb-italian.team.ATA": "ATA",
  "abbr.sb-italian.team.BOL": "BOL",
  "abbr.sb-italian.team.BRE": "BRE",
  "abbr.sb-italian.team.CAG": "CAG",
  "abbr.sb-italian.team.CHI": "CHI",
  "abbr.sb-italian.team.FIO": "FIO",
  "abbr.sb-italian.team.GEN": "GEN",
  "abbr.sb-italian.team.INT": "INT",
  "abbr.sb-italian.team.JUV": "JUV",
  "abbr.sb-italian.team.LAZ": "LAZ",
  "abbr.sb-italian.team.NAP": "NAP",
  "abbr.sb-italian.team.ROM": "ROM",
  "abbr.sb-italian.team.SAM": "SAM",
  "abbr.sb-italian.team.UDI": "UDI",
  "abbr.sb-italian.team.VER": "VER",
  "abbr.sb-greek.team.AEK": "AEK",
  "abbr.sb-greek.team.APS": "APS",
  "abbr.sb-greek.team.ARI": "ARI",
  "abbr.sb-greek.team.AST": "AST",
  "abbr.sb-greek.team.ATR": "ATR",
  "abbr.sb-greek.team.GIA": "GIA",
  "abbr.sb-greek.team.LEV": "LEV",
  "abbr.sb-greek.team.OFI": "OFI",
  "abbr.sb-greek.team.OLM": "OLM",
  "abbr.sb-greek.team.PTK": "PTK",
  "abbr.sb-greek.team.PNS": "PNS",
  "abbr.sb-greek.team.PAO": "PAO",
  "abbr.sb-greek.team.PLT": "PLT",
  "abbr.sb-greek.team.XAN": "XAN",
  "sb-turkish.team.AKB": "AKHİSARSPOR",
  "sb-turkish.team.BES": "BEŞIKTAŞ",
  "sb-turkish.team.FEN": "FENERBAHÇE",
  "sb-turkish.team.GAL": "GALATASARAY",
  "sb-turkish.team.TRA": "TRABZOSPOR",
  "sb-turkish.team.ANT": "ANTALYASPOR",
  "sb-turkish.team.GEN": "GENÇLERBİRLİĞİ",
  "sb-turkish.team.KAS": "KASIMPAŞA",
  "sb-turkish.team.BUR": "BURSAPOR",
  "sb-turkish.team.KAY": "KAYSERİSPOR",
  "sb-turkish.team.SIV": "SVASPOR",
  "sb-turkish.team.IBA": "İSTANBUL BAŞAKŞEHIR",
  "sb-turkish.team.HAT": "HATAYSPOR",
  "sb-turkish.team.ADS": "AD. DEMIRSPOR",
  "sb-turkish.team.ALT": "ALTAY",
  "sb-turkish.team.GAZ": "GAZIANTEP",
  "sb-turkish.team.GOZ": "GÖZTEPE",
  "sb-turkish.team.KON": "KONYASPOR",
  "sb-turkish.team.CRS": "C. RIZESPOR",
  "sb-turkish.team.ALS": "ALANYASPOR",
  "abbr.sb-turkish.team.AKB": "AKB",
  "abbr.sb-turkish.team.BES": "BES",
  "abbr.sb-turkish.team.FEN": "FEN",
  "abbr.sb-turkish.team.GAL": "GAL",
  "abbr.sb-turkish.team.TRA": "TRA",
  "abbr.sb-turkish.team.ANT": "ANT",
  "abbr.sb-turkish.team.GEN": "GEN",
  "abbr.sb-turkish.team.KAS": "KAS",
  "abbr.sb-turkish.team.BUR": "RZEP",
  "abbr.sb-turkish.team.KAY": "KAY",
  "abbr.sb-turkish.team.SIV": "SIV",
  "abbr.sb-turkish.team.IBA": "IBA",
  "abbr.sb-turkish.team.HAT": "HAT",
  "abbr.sb-turkish.team.ADS": "ADS",
  "abbr.sb-turkish.team.ALT": "ALT",
  "abbr.sb-turkish.team.GAZ": "GAZ",
  "abbr.sb-turkish.team.GOZ": "GOZ",
  "abbr.sb-turkish.team.KON": "KON",
  "abbr.sb-turkish.team.CRS": "KSR",
  "abbr.sb-turkish.team.ALS": "ALS",
  "sb-english.team.BRE": "Brentford",
  "abbr.sb-english.team.BRE": "BRE",
  "sb-english.team.NOT": "Nottingham F.",
  "abbr.sb-english.team.NOT": "NOT",
  "sb-spanish.team.ALV": "Alaves",
  "sb-spanish.team.ATB": "Athletic Bilbao",
  "sb-spanish.team.ATM": "Atletico Madryt",
  "sb-spanish.team.FCB": "Barcelona",
  "sb-spanish.team.CAD": "Kadyks",
  "sb-spanish.team.CLV": "Celta Vigo",
  "sb-spanish.team.ESP": "Espanyol",
  "sb-spanish.team.GET": "Getafe",
  "sb-spanish.team.GIR": "Girona",
  "sb-spanish.team.GRA": "Granada",
  "sb-spanish.team.LAP": "Las Palmas",
  "sb-spanish.team.MAL": "Majorka",
  "sb-spanish.team.OSA": "Osasuna",
  "sb-spanish.team.RAY": "Rayo Vallecano",
  "sb-spanish.team.BET": "Real Betis",
  "sb-spanish.team.MAD": "Real Madryt",
  "sb-spanish.team.SOC": "Real Scoiedad",
  "sb-spanish.team.SEV": "Sewilla",
  "sb-spanish.team.VAL": "Walencja",
  "sb-spanish.team.VIL": "Villarreal",
  "abbr.sb-spanish.team.ALV": "ALV",
  "abbr.sb-spanish.team.ATB": "ATB",
  "abbr.sb-spanish.team.ATM": "ATM",
  "abbr.sb-spanish.team.FCB": "FCB",
  "abbr.sb-spanish.team.CAD": "CAD",
  "abbr.sb-spanish.team.CLV": "CLV",
  "abbr.sb-spanish.team.ESP": "ESP",
  "abbr.sb-spanish.team.GET": "GET",
  "abbr.sb-spanish.team.GIR": "GIR",
  "abbr.sb-spanish.team.GRA": "GRA",
  "abbr.sb-spanish.team.LAP": "LAP",
  "abbr.sb-spanish.team.MAL": "MAL",
  "abbr.sb-spanish.team.OSA": "OSA",
  "abbr.sb-spanish.team.RAY": "RAY",
  "abbr.sb-spanish.team.BET": "BET",
  "abbr.sb-spanish.team.MAD": "MAD",
  "abbr.sb-spanish.team.SOC": "SOC",
  "abbr.sb-spanish.team.SEV": "SEV",
  "abbr.sb-spanish.team.VAL": "VAL",
  "abbr.sb-spanish.team.VIL": "VIL",
  "sb-scottish.team.ABE": "Aberdeen",
  "sb-scottish.team.CEL": "Celtic",
  "sb-scottish.team.DDU": "Dundee United",
  "sb-scottish.team.HEA": "Serca",
  "sb-scottish.team.HIB": "Hiberian",
  "sb-scottish.team.KIL": "Kilmarnock",
  "sb-scottish.team.LIV": "Livingston",
  "sb-scottish.team.MOT": "Motherwell",
  "sb-scottish.team.RAN": "Rangersi",
  "sb-scottish.team.STJ": "St Johnstone",
  "sb-scottish.team.STM": "St Mirren",
  "sb-scottish.team.DDE": "Dundee",
  "abbr.sb-scottish.team.ABE": "ABE",
  "abbr.sb-scottish.team.CEL": "CEL",
  "abbr.sb-scottish.team.DDU": "DDU",
  "abbr.sb-scottish.team.HEA": "HEA",
  "abbr.sb-scottish.team.HIB": "HIB",
  "abbr.sb-scottish.team.KIL": "KIL",
  "abbr.sb-scottish.team.LIV": "LIV",
  "abbr.sb-scottish.team.MOT": "MOT",
  "abbr.sb-scottish.team.RAN": "RAN",
  "abbr.sb-scottish.team.STJ": "STJ",
  "abbr.sb-scottish.team.STM": "STM",
  "abbr.sb-scottish.team.DDE": "DDE",
  "iihf-row.team.CAN": "Kanada",
  "iihf-row.team.FIN": "Finlandia",
  "iihf-row.team.RUS": "Rosja",
  "iihf-row.team.USA": "Stany Zjednoczone",
  "iihf-row.team.CZE": "Czechy",
  "iihf-row.team.SWE": "Szwecja",
  "iihf-row.team.SVK": "Słowacja",
  "iihf-row.team.NOR": "Norwegia",
  "iihf-row.team.DEN": "Dania",
  "abbr.iihf-row.team.CAN": "CAN",
  "abbr.iihf-row.team.FIN": "FIN",
  "abbr.iihf-row.team.RUS": "RUS",
  "abbr.iihf-row.team.USA": "USA",
  "abbr.iihf-row.team.CZE": "CZE",
  "abbr.iihf-row.team.SWE": "SWE",
  "abbr.iihf-row.team.SVK": "SVK",
  "abbr.iihf-row.team.NOR": "NOR",
  "abbr.iihf-row.team.DEN": "DEN",
  "event.Icematchresnt": "Wynik meczu (1X2) (regulaminowy czas gry)",
  "event.Icematchresot": "Wynik meczu (1,2) (w tym dogrywka)",
  "event.Icebothteamstoscore": "Obie drużyny strzelą gola (regulaminowy czas gry)",
  "event.Icecorrectscoreot": "Prawidłowy wynik (łącznie z dogrywką)",
  "event.Iceexactgoalsot": "Dokładne bramki (łącznie z dogrywką)",
  "event.Icegamelines2nt": "Linie gry 2-way (regulaminowy czas gry)",
  "event.Icegamelines3nt": "Game Lines 3-way (regulaminowy czas gry)",
  "event.Iceou2p5totalgoalsot": "Powyżej 2,5 gola (wliczając dogrywkę)",
  "event.Iceou3p5totalgoalsot": "Powyżej 3,5 gola (wliczając dogrywkę)",
  "event.Iceou4p5totalgoalsot": "Powyżej 4,5 goli (łącznie z dogrywką)",
  "event.Iceteamaexactgoalsot": "Dokładne bramki drużyny gospodarzy (łącznie z dogrywką)",
  "event.Iceteambexactgoalsot": "Dokładne bramki drużyny przeciwnej (łącznie z dogrywką)",
  "event.Icematchresou3p5totalgoalsnt": "Wynik meczu i powyżej/poniżej 3,5 gola (regulaminowy czas gry)",
  "event.Icematchresou3p5totalgoalsot": "Wynik meczu i powyżej/poniżej 3,5 gola (w tym dogrywka)",
  "event.Icehighestscoreperiodnt": "Najwyżej punktowane okresy gry (regulaminowy czas gry)",
  "event.Iceou25goalsteamateambot": "Powyżej/poniżej 2,5 gola dla gospodarzy lub gości (wliczając dogrywkę)",
  "event.Icefirstteamtoscore": "Która drużyna pierwsza strzeli gola? (Łącznie z dogrywką)",
  "event.Iceteamtowinmostperiods": "Drużyna, która wygrała najwięcej okresów (regulaminowy czas gry)",
  "selection.A": "{home}",
  "selection.B": "{away}",
  "selection.A -3.5": "{home} -3.5",
  "selection.A -3.0": "{home} -3.0",
  "selection.A -2.5": "{home} -2.5",
  "selection.A -2.0": "{home} -2.0",
  "selection.A -1.5": "{home} -1.5",
  "selection.A -1.0": "{home} -1.0",
  "selection.A +1.0": "{home} +1.0",
  "selection.A +1.5": "{home} +1.5",
  "selection.A +2.0": "{home} +2.0",
  "selection.A +2.5": "{home} +2.5",
  "selection.A +3.0": "{home} +3.0",
  "selection.A +3.5": "{home} +3.5",
  "selection.B -3.5": "{away} -3.5",
  "selection.B -3.0": "{away} -3.0",
  "selection.B -2.5": "{away} -2.5",
  "selection.B -2.0": "{away} -2.0",
  "selection.B -1.5": "{away} -1.5",
  "selection.B -1.0": "{away} -1.0",
  "selection.B +1.0": "{away} +1.0",
  "selection.B +1.5": "{away} +1.5",
  "selection.B +2.0": "{away} +2.0",
  "selection.B +2.5": "{away} +2.5",
  "selection.B +3.0": "{away} +3.0",
  "selection.B +3.5": "{away} +3.5",
  "selection.X -3.0": "X -3.0",
  "selection.X -2.0": "X -2.0",
  "selection.X -1.0": "X -1.0",
  "selection.X +1.0": "X +1.0",
  "selection.X +2.0": "X +2.0",
  "selection.X +3.0": "X +3.0",
  "selection.A & Over": "{home} & Over",
  "selection.A & Under": "{home} & Under",
  "selection.X & Over": "X & Over",
  "selection.X & Under": "X & Under",
  "selection.B & Over": "{away} & Over",
  "selection.B & Under": "{away} & Under",
  "selection.A Over": "{home} Over",
  "selection.A Under": "{home} Under",
  "selection.B Over": "{away} Over",
  "selection.B Under": "{away} Under"
}
